import { Screen } from '@bonanza-social/navigation';
import UploadDocumentsInfo from '../../components/UploadDocumentsInfo/UploadDocumentsInfo';

function UploadDocumentsInfoScreen() {
  return (
    <Screen paddingHorizontal="space-0" paddingBottom="safe-area-inset-bottom">
      <UploadDocumentsInfo />
    </Screen>
  );
}

export default UploadDocumentsInfoScreen;
